import LinesIcon from '../../../images/lines.svg?component';
import ROUTE_NAMES from '../routeNames';
import SECTION_NAMES from '../sectionNames';
import { usePermissionsStore } from '@/vue/stores/permissions';

const meta = {
    title: SECTION_NAMES.TEMPLATES,
    icon: LinesIcon,
    permissions: (): string[] => [usePermissionsStore().allPermissions.adminTemplates],
};

export default [
    {
        path: '',
        name: ROUTE_NAMES.ADMIN_TEMPLATE_LIST,
        component: (): Promise<unknown> => import('../../views/admin/AdminTemplate/AdminTemplateList.vue'),
        meta,
    },
    {
        path: 'view/:id',
        name: ROUTE_NAMES.ADMIN_TEMPLATE_VIEW,
        component: (): Promise<unknown> => import('../../views/admin/AdminTemplate/AdminTemplateView.vue'),
        meta,
    },
    {
        path: 'new',
        name: ROUTE_NAMES.ADMIN_TEMPLATE_NEW,
        component: (): Promise<unknown> => import('../../views/admin/AdminTemplate/AdminTemplateView.vue'),
        meta,
    },
];
